module.exports = __webpack_public_path__ + "media/images/home/faq_title_bg-1a3e9cb303a4d6d8e01c5d37f926033d.png";